import throttle from 'lodash.throttle'
import MenuSide from './components/menu_side'

class CPage {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      // console.log('[Page.js] online')
      this.sideLeft = document.querySelector('aside.is-left')
      this.sideRight = document.querySelector('aside.is-right')

      this.initEventSide()
      const menu = new MenuSide()
    })
  }

  initEventSide() {
    const article = document.querySelector('article > .article-body')

    if (article) {
      const setArticleHeight = () => {
        requestAnimationFrame(() => {
          const sideHeight = Math.max(
            this.sideLeft?.offsetHeight || 0,
            this.sideRight?.offsetHeight || 0
          )

          article.style.minHeight = null
          const articleHeight = article.offsetHeight

          // console.log(articleHeight, sideHeight)
          if (articleHeight < sideHeight)
            article.style.minHeight = sideHeight + 'px'
        })
      }

      setArticleHeight()
      window.addEventListener('resize', throttle(setArticleHeight, 100))

      if (this.sideRight) {
        const sticky = this.sideRight.querySelector(
          '.aside-sticky.is-transparent'
        )
        if (sticky) {
          const articleTop =
            article.getBoundingClientRect().top +
            document.documentElement.scrollTop -
            60

          const checkScroll = () => {
            const pageY = window.scrollY
            sticky.classList.toggle('is-transparent', pageY <= articleTop)
          }

          document.addEventListener('scroll', throttle(checkScroll, 100))
        }
      }
    }
  }
}

const Page = new CPage()
export default Page
